var cart_page_config = {
    // end hour for Tuesday, Moday, Sunday
    specialDaysHour: 19,
    // end hour for all days
    allDaysHour: 19,
    // [start_interval, end_interval, value, option]
    defaultCheckoutInterval: [
        [12, 19, 'ASAP', 'ASAP'],
        [0, 11, '01:00PM-03:00PM', '1:00PM to 3:00PM'],
        [0, 12, '02:00PM-04:00PM', '2:00PM to 4:00PM'],
        [0, 13, '03:00PM-05:00PM', '3:00PM to 5:00PM'],
        [0, 14, '04:00PM-06:00PM', '4:00PM to 6:00PM'],
        [0, 15, '05:00PM-07:00PM', '5:00PM to 7:00PM'],
        [0, 16, '06:00PM-08:00PM', '6:00PM to 8:00PM'],
        [0, 17, '07:00PM-09:00PM', '7:00PM to 9:00PM'],
    ],
    // "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    checkoutIntervalPerDays: {
        'Sunday': [],
        'Monday': [],
        'Tuesday': [],
        'Wednesday': [],
        'Thursday': [],
        'Friday': [],
        'Saturday': [],
    },
     sameDayOptions: [
        [0, 17, 'Next Day Delivery', 'Next Day Delivery']
    ],
    sameDayMaxTime: 17,
    disableSameDay: ["2021-05-31", "2021-08-22", "2021-08-23", "2022-07-05"],
    disableOnDemandDay: ["2021-05-31", "2021-08-22", "2021-08-23"]
}